import "./sendapplication.scss";
import React from "react";
import { Modal } from "react-bootstrap";
import cross from "images/cross.svg";
import graybackarrow from "images/graybackarrow.svg";
import moment from "moment";

import { inject, observer } from "mobx-react";
import { sendMetriks } from "utils/metriks";

import "moment/locale/ru";
moment.locale("ru");

const SendApplicationModal = ({
  setModalShowCenterDate,
  setSendApplicationModal,
  setSelectedVacancy,
  selectedVacancy,
  setSelectedCandidate,
  selectedCandidate,
  setSelectedCenter,
  selectedCenter,
  setSelectedDate,
  selectedDate,
  getApplicationsForCandidate,

  setApplicationSuccessModal,
  vacancies,
  positions,
  cities,
  education_centers,
  candidates,
  sendCandidateOnVacancy,
  refreshCandidateOnVacancy,
  updateApplication,
  updateVacancyCandidateId,
  setUpdateVacancyCandidateId,
  applications,
  show,
  onHide
}) => {
  const send = () => {
    // Режим "Обновить отклик": обновляем существующий отклик — вакансия,
    // учебный центр и дата. Отклик поднимается в топ силами бэка.
    if (updateVacancyCandidateId) {
      updateApplication({
        vacancy_candidate_id: updateVacancyCandidateId,
        vacancy_id: selectedVacancy,
        date_arrival: moment(selectedDate, "llll").format("YYYY-MM-DD"),
        education_center_id: selectedCenter
      });
      setUpdateVacancyCandidateId("");
      setApplicationSuccessModal(true);
      setSendApplicationModal(false);
      setSelectedVacancy("");
      setSelectedCenter("");
      setSelectedDate("");
      setSelectedCandidate("");
      return;
    }

    let application = false;
    for (let j = 0; j < applications.length; j++) {
      if (
        selectedVacancy === applications[j]["vacancy_id"] &&
        selectedCandidate === applications[j]["candidate_id"]
      ) {
        if (
          applications[j]["status_id"] ===
            "f1f5364f32642699346e0c1b4bc83dab42008f9e" ||
          applications[j]["date_arrival"] === null
        ) {
          refreshCandidateOnVacancy({
            vacancy_candidate_id: applications[j]["vacancy_candidate_id"],
            date_arrival: moment(selectedDate, "llll").format("YYYY-MM-DD"),
            education_center_id: selectedCenter
          });
          application = true;
        } else {
          sendCandidateOnVacancy({
            candidate_id: selectedCandidate,
            vacancy_id: selectedVacancy,
            date_arrival: moment(selectedDate, "llll").format("YYYY-MM-DD"),
            education_center_id: selectedCenter
          });
          application = true;
        }
        break;
      }
    }
    if (application === false) {
      sendCandidateOnVacancy({
        candidate_id: selectedCandidate,
        vacancy_id: selectedVacancy,
        date_arrival: moment(selectedDate, "llll").format("YYYY-MM-DD"),
        education_center_id: selectedCenter
      });
      application = false;
    }
    setApplicationSuccessModal(true);
    setSendApplicationModal(false);

    setSelectedVacancy("");
    setSelectedCenter("");
    setSelectedDate("");
    getApplicationsForCandidate({
      candidate_id: selectedCandidate
    });
    setSelectedCandidate("");
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      size="lg"
      backdrop="static"
    >
      <Modal.Body className="choosecenterdate">
        <div className="choosecenterdate__top">
          <div
            className="choosecenterdate__top-back"
            onClick={() => {
              setSendApplicationModal(false);
              setModalShowCenterDate(true);
              setSelectedCenter("");
              setSelectedVacancy("");
              setSelectedDate("");
            }}
          >
            <img src={graybackarrow} alt="" />
            <p className="choosecenterdate__top-back-text">Назад</p>
          </div>
          <img
            src={cross}
            onClick={() => {
              setSendApplicationModal(false);
              setSelectedCandidate("");
              setSelectedVacancy("");
              setSelectedCenter("");
              setSelectedDate("");
              setUpdateVacancyCandidateId("");
            }}
            alt=""
          />
        </div>
        <div className="choosevacancy-main">
          <p className="choosevacancy-title">Отправьте отклик</p>
          <div className="choosecenterdate-wrapper-text">
            <div className="choosevacancy-text">
              <p className="choosevacancy-subtitle">Кандидат:</p>
              <span className="choosevacancy-value">
                {selectedCandidate &&
                  candidates.length > 0 &&
                  candidates.map((candidate) => {
                    if (candidate["id"] === selectedCandidate) {
                      return (
                        <span key={candidate.id}>
                          {candidate["surname"]} {candidate["name"]}{" "}
                          {candidate["patronymic"]}
                        </span>
                      );
                    }
                    return null;
                  })}
              </span>
            </div>
            <div className="choosevacancy-text">
              <p className="choosevacancy-subtitle">Вакансия:</p>
              {vacancies.length > 0 &&
                vacancies.map((vacancy) => {
                  if (
                    vacancy["id"] === selectedVacancy &&
                    positions[vacancy["position_id"]]
                  ) {
                    return (
                      <React.Fragment key={vacancy.id}>
                        <p className="choosevacancy-value">
                          {
                            positions[vacancy["position_id"]]["title"].split(
                              / (\d)/
                            )[0]
                          }
                        </p>
                        {cities[vacancy.city_id]["title"] ? (
                          <p className="choosevacancy-value">
                            г. {cities[vacancy.city_id]["title"]}
                          </p>
                        ) : (
                          ""
                        )}
                      </React.Fragment>
                    );
                  }
                  return null;
                })}
            </div>

            <div className="choosevacancy-text">
              <p className="choosevacancy-subtitle">Город:</p>
              {selectedCenter && education_centers[selectedCenter] ? (
                <p className="choosevacancy-value">
                  г. {education_centers[selectedCenter]["title"]}
                </p>
              ) : null}
            </div>
            <div className="choosevacancy-text">
              <p className="choosevacancy-subtitle">Дата прибытия:</p>
              <p className="choosevacancy-value">
                {moment(selectedDate).locale("ru").format("D MMMM YYYY, dddd")}
              </p>
            </div>
          </div>

          <button
            onClick={() => {
              send();
              sendMetriks("reachGoal", "resp_5");
            }}
            className="card-candidate-mainbtn"
            disabled={!selectedDate}
          >
            Отправить
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default inject(
  ({ usersStore, vacanciesStore, candidatesStore, modalWindows }) => {
    const {
      vacancies,
      allvacancies,
      positions,
      cities,
      statuses,
      getVacanciesData
    } = vacanciesStore;
    const {
      setApplicationSuccessModal,
      setSendApplicationModal,
      setModalShowCenterDate
    } = modalWindows;

    const {
      approvePhoneCode,
      approvedPhone,

      checkPhoneCode,
      cleanErrorRegistration,
      errorCode
    } = usersStore;
    const {
      education_centers,
      candidates,
      setSelectedVacancy,
      selectedVacancy,
      setSelectedCandidate,
      selectedCandidate,
      setSelectedCenter,
      selectedCenter,
      setSelectedDate,
      selectedDate,
      getApplicationsForCandidate,
      applications,
      getApplications,
      sendCandidateOnVacancy,
      refreshCandidateOnVacancy,
      updateApplication,
      updateVacancyCandidateId,
      setUpdateVacancyCandidateId
    } = candidatesStore;
    return {
      checkPhoneCode,
      cleanErrorRegistration,
      approvedPhone,
      approvePhoneCode,
      vacancies,
      getApplications,
      applications,
      allvacancies,
      getVacanciesData,
      positions,
      cities,
      statuses,
      education_centers,
      candidates,
      sendCandidateOnVacancy,
      refreshCandidateOnVacancy,
      updateApplication,
      updateVacancyCandidateId,
      setUpdateVacancyCandidateId,
      setSelectedVacancy,
      selectedVacancy,
      setSelectedCandidate,
      selectedCandidate,
      setSelectedCenter,
      selectedCenter,
      setSelectedDate,
      selectedDate,
      getApplicationsForCandidate,
      errorCode,
      setApplicationSuccessModal,
      setSendApplicationModal,
      setModalShowCenterDate
    };
  }
)(observer(SendApplicationModal));
